<div class="lesson-content">
    <div>
        <app-icon [type]="lessonContent.type" class="d-block selenium-card-media-type"></app-icon>
    </div>
    <div class="ms-4" [ngClass]="{ 'w-100': lessonContent.contentFlags.length }">
        <a
            href="#"
            (click)="goToResource($event)"
            [ngClass]="{
                'd-flex flex-row justify-content-between': lessonContent.contentFlags.length,
            }"
            class="lesson-content-title mb-2 d-block gtm-lesson-content-item selenium-lesson-content-item"
            [title]="lessonContent.title"
        >
            <span>{{ lessonContent.title }}</span>
            <span class="caution-flag-icon" *ngIf="lessonContent.contentFlags.length">
                <app-icon [type]="'Exclamation-Circle'" class="media-icon exclamation mx-3">
                </app-icon>
            </span>
        </a>
        <h6 class="lesson-content-media-type mb-0">{{ lessonContent.type.toUpperCase() }}</h6>
    </div>
</div>
